// @@ check is item variation

export function CheckIsVariation(data: any) {
    return (data?.item_variation?.length > 0 && data?.variation_status != 0)
}

// @@ check is item type addon

export function CheckIsAddOn(data: any) {
    return (data?.addon_data?.length > 0 && data?.addon_status == 1)
}


// @@ check is customize 

export function CheckIsCustomize(data: any) {
    return (data?.customize_status == 1)
}

export function CheckIsItemNormal(data: any) {
    if (CheckIsVariation(data) || CheckIsAddOn(data) || CheckIsCustomize(data)) {
        return false
    }
    return true;
}